import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_11 = { class: "col-sm-8" }
const _hoisted_12 = ["readonly"]
const _hoisted_13 = { class: "row mt-2" }
const _hoisted_14 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_15 = { class: "col-sm-8" }
const _hoisted_16 = { class: "invoice-input-group mb-0" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_20 = { class: "col-sm-12" }
const _hoisted_21 = {
  key: 0,
  class: "small"
}
const _hoisted_22 = {
  key: 1,
  class: "small"
}
const _hoisted_23 = { class: "row mt-2" }
const _hoisted_24 = {
  for: "currency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_25 = { class: "col-sm-8" }
const _hoisted_26 = { class: "row mt-2" }
const _hoisted_27 = {
  for: "minAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_28 = { class: "col-sm-8" }
const _hoisted_29 = { class: "row mt-2" }
const _hoisted_30 = {
  for: "maxAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_31 = { class: "col-sm-8" }
const _hoisted_32 = { class: "row mt-2" }
const _hoisted_33 = {
  for: "payoutFeeAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_34 = { class: "col-sm-8" }
const _hoisted_35 = { class: "row mt-2" }
const _hoisted_36 = {
  for: "allowedPaymentOptions",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_37 = { class: "col-sm-8" }
const _hoisted_38 = { class: "row mt-2" }
const _hoisted_39 = {
  for: "defaultPaymentOption",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_40 = { class: "col-sm-8" }
const _hoisted_41 = { class: "row mt-2" }
const _hoisted_42 = {
  for: "useProviderAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_43 = { class: "col-sm-8" }
const _hoisted_44 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_45 = { class: "row mt-2" }
const _hoisted_46 = {
  for: "config",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_47 = { class: "col-sm-12" }
const _hoisted_48 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_49 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_50 = { class: "col-sm-12" }
const _hoisted_51 = { class: "table table-sm table-bordered mb-0" }
const _hoisted_52 = { class: "row mt-2" }
const _hoisted_53 = {
  for: "responseAllowlist",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_54 = { class: "col-sm-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.type")) + ":", 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`name`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  id: "name",
                  class: _normalizeClass(["", parentProps.class]),
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                  options: _ctx.configs.map((item) => item.name),
                  "custom-label": (opt) => `${opt}`,
                  multiple: false,
                  "select-label": "Select",
                  readonly: !!_ctx.form.id,
                  disabled: !!_ctx.form.id,
                  placeholder: ""
                }, null, 8, ["modelValue", "options", "custom-label", "class", "readonly", "disabled"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.trader")) + ":", 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`traderId`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_TraderMultiselect, {
                  class: _normalizeClass(parentProps.class),
                  isProvider: true,
                  multiple: false,
                  small: false,
                  modelValue: _ctx.form.trader,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.trader) = $event)),
                  disabled: !!_ctx.form.id
                }, null, 8, ["class", "modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.helper.trans("labels.sysname")) + ":", 1),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`name`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  readonly: !!_ctx.form.id,
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.sysname) = $event)),
                  type: "text",
                  id: "name"
                }, null, 10, _hoisted_12), [
                  [_vModelText, _ctx.form.sysname]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.helper.trans("labels.callback_url")) + ":", 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control font-monospace",
                  style: {"font-size":"12px"},
                  value: _ctx.callbackUrl,
                  readonly: ""
                }, null, 8, _hoisted_18),
                _createVNode(_component_copy_button, {
                  class: "btn btn-copy",
                  value: _ctx.callbackUrl
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        (_ctx.webhookAuth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", {
                  class: _normalizeClass([_ctx.webhookAuth.isWarning ? 'alert-warning' : 'alert-success', "alert mb-0 py-2"])
                }, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans("labels.webhook_auth")) + ": " + _toDisplayString(_ctx.helper.trans(`webhook_auth.${_ctx.webhookAuth.level}`)), 1),
                  (_ctx.webhookAuth.note)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.webhookAuth.note), 1))
                    : _createCommentVNode("", true),
                  (_ctx.webhookAuth.requiredConfigFields.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createTextVNode(_toDisplayString(_ctx.helper.trans("labels.webhook_auth_required_fields")) + ": ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.webhookAuth.requiredConfigFields, (field) => {
                          return (_openBlock(), _createElementBlock("code", {
                            key: field,
                            class: "me-1"
                          }, _toDisplayString(field), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.helper.trans("labels.currency")), 1),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_FormInputWrapper, {
              field: "currency",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  id: "currency",
                  class: _normalizeClass(["", parentProps.class]),
                  modelValue: _ctx.form.currency,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.currency) = $event)),
                  options: _ctx.store.getters['currencyMethods/currencies'],
                  "custom-label": (opt) => `${opt}`,
                  multiple: false,
                  "select-label": "Select",
                  placeholder: ""
                }, null, 8, ["modelValue", "options", "custom-label", "class"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.helper.trans("labels.from_sum")), 1),
          _createElementVNode("div", _hoisted_28, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.minPayInAmount) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.minPayInAmount]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.helper.trans("labels.to_sum")), 1),
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.maxPayInAmount) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.maxPayInAmount]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.helper.trans("labels.payout_fee_amount")), 1),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`payoutFeeAmount`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  type: "number",
                  step: "0.01",
                  min: "0",
                  id: "payoutFeeAmount",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.payoutFeeAmount) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.form.payoutFeeAmount]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.helper.trans("labels.payment_options")), 1),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_Multiselect, {
              id: "allowedPaymentOptions",
              modelValue: _ctx.form.allowedPaymentOptions,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.allowedPaymentOptions) = $event)),
              options: _ctx.store.getters['currencyMethods/options'](),
              "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
              multiple: true,
              "select-label": "Select",
              placeholder: _ctx.helper.trans('labels.payment_options')
            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.helper.trans("labels.default")), 1),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`defaultPaymentOption`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  id: "defaultPaymentOption",
                  class: _normalizeClass(parentProps.class),
                  modelValue: _ctx.form.defaultPaymentOption,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.defaultPaymentOption) = $event)),
                  options: _ctx.store.getters['currencyMethods/options'](),
                  "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                  multiple: false,
                  "select-label": "Select",
                  placeholder: _ctx.helper.trans('labels.payment_options')
                }, null, 8, ["class", "modelValue", "options", "custom-label", "placeholder"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.helper.trans("labels.use_provider_amount")), 1),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.useProviderAmount) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "useProviderAmount"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.useProviderAmount]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.helper.trans("labels.config")), 1),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getFieldErrors('config')
            }, {
              default: _withCtx((parentProps) => [
                _createElementVNode("textarea", {
                  ref: "configField",
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  rows: "8"
                }, null, 2)
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        (_ctx.configDocs && Object.keys(_ctx.configDocs).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.helper.trans("labels.config_docs")), 1),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("table", _hoisted_51, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans("labels.field")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans("labels.type")), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans("labels.comment")), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configDocs, (doc, field) => {
                      return (_openBlock(), _createElementBlock("tr", { key: field }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("code", null, _toDisplayString(field), 1)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(doc.type), 1),
                        _createElementVNode("td", null, _toDisplayString(doc.comment), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.helper.trans("labels.response_allowlist")), 1),
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getFieldErrors('responseAllowlist')
            }, {
              default: _withCtx((parentProps) => [
                _createElementVNode("textarea", {
                  ref: "responseAllowlistField",
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  rows: "6"
                }, null, 2)
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ])
      ])
    ])
  ]))
}